/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   ResidentQuotesModal reducer
 */

import { alwaysReducer, payloadReducer } from '@zcode/reducers'
import type { ResidentQuotesModal } from '@zcode/state-type'
import { handleActions } from 'redux-actions'
import { CLEAR_DATA, RECEIVE_DATA } from '../constants/residentQuotesModal'
import type { ActionTypes } from '../types'

const DEFAULT_STATE = {
  isPostLead: false,
  nextAction: undefined,
  entity: undefined,
} as const satisfies ResidentQuotesModal

export const residentQuotesModalReducer = handleActions<ResidentQuotesModal, ActionTypes>(
  {
    [CLEAR_DATA]: alwaysReducer(DEFAULT_STATE),
    [RECEIVE_DATA]: payloadReducer,
  },
  DEFAULT_STATE
)
